import React from "react";
import ReusableInput from "components/Inputs/ReusableInput";


// Reusable category selection component
const CategorySelect = ({ value, onChange, isRequired = false }) => {
  const categories = [
    "Getting Started",
    "Payments",
    "Account Issues",
    "Technical Support",
    "Driver Support",
    "Driver Partner",
    "Agent",
    "General",
  ];

  const options = categories.map((category) => ({
    value: category,
    label: category,
  }));

  return (
    <ReusableInput
      label="Category"
      name="category"
      value={value}
      onChange={onChange}
      type="select"
      options={options}
      isRequired={isRequired}
      placeholder="Select category"
    />
  );
};

export default CategorySelect;
